export const BANK_DATA = {
  owner: "George Maier",
  iban: "DE75 7015 0000 0023 1729 92",
  bic: "SSKMDEMMXXX",
};
